import { RouteConfig } from '@acsbe/routing';
import { RouterContext } from '../../../router';
import * as index from './_';

const route: RouteConfig<RouterContext> = {
  ...index,
};
export default route;
